import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const REPORT_ICONS = {
    production: "fa-chart-bar",
    efficiency: "fa-tachometer-alt",
    onoff: "fa-toggle-on",
    live: "fa-broadcast-tower",
    default: "fa-star",
};

function reportIcon(parameters) {
    if (!parameters) return REPORT_ICONS.default;
    const p = typeof parameters === "string" ? parameters.toLowerCase() : JSON.stringify(parameters).toLowerCase();
    if (p.includes("production")) return REPORT_ICONS.production;
    if (p.includes("efficiency")) return REPORT_ICONS.efficiency;
    if (p.includes("onoff") || p.includes("on_off")) return REPORT_ICONS.onoff;
    if (p.includes("live")) return REPORT_ICONS.live;
    return REPORT_ICONS.default;
}

function CardSpinner() {
    return (
        <div style={{
            position: "absolute", inset: 0, background: "rgba(255,255,255,0.8)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 10, borderRadius: "inherit",
        }}>
            <i className="fa fa-spinner fa-spin" style={{ fontSize: "2rem", color: "#6c757d" }} />
        </div>
    );
}

function FavReportsStrip({ favReports, loading }) {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();

    if (!favReports?.length) return null;

    return (
        <div className={`card card-outline card-info dashboard-strip-card ${collapsed ? "collapsed-card" : ""}`} style={{ position: "relative" }}>
            {loading && <CardSpinner />}
            <div className="card-header py-2">
                <h3 className="card-title">
                    <i className="fa fa-star mr-2 text-warning" />
                    Favourite Reports
                </h3>
                <div className="card-tools">
                    <Link to="/fav-reports" className="btn btn-tool btn-sm text-muted">
                        <i className="fa fa-external-link" />
                    </Link>
                    <button type="button" className="btn btn-tool" onClick={() => setCollapsed(!collapsed)}>
                        <i className={`fas ${collapsed ? "fa-plus" : "fa-minus"}`} />
                    </button>
                </div>
            </div>
            <div className={`card-body py-2 px-3 ${collapsed ? "d-none" : ""}`}>
                <div
                    style={{
                        display: "flex",
                        overflowX: "auto",
                        gap: 12,
                        paddingBottom: 4,
                    }}
                >
                    {favReports.map((report) => (
                        <div
                            key={report.id}
                            style={{
                                minWidth: 200,
                                maxWidth: 240,
                                border: "1px solid #dee2e6",
                                borderRadius: 8,
                                padding: "12px 14px",
                                background: "#fff",
                                flexShrink: 0,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                            }}
                        >
                            <div>
                                <div className="d-flex align-items-center mb-1">
                                    <span
                                        className="rounded-circle d-flex align-items-center justify-content-center mr-2 flex-shrink-0"
                                        style={{ width: 28, height: 28, background: "rgba(0,115,183,0.10)" }}
                                    >
                                        <i className={`fa ${reportIcon(report.parameters)} text-primary`} style={{ fontSize: "0.75rem" }} />
                                    </span>
                                    <span
                                        className="font-weight-bold text-truncate"
                                        style={{ fontSize: "0.82rem" }}
                                        title={report.name}
                                    >
                                        {report.name}
                                    </span>
                                </div>
                                {report.description && (
                                    <p
                                        className="text-muted mb-2"
                                        style={{
                                            fontSize: "0.72rem",
                                            overflow: "hidden",
                                            display: "-webkit-box",
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: "vertical",
                                        }}
                                    >
                                        {report.description}
                                    </p>
                                )}
                            </div>
                            <button
                                className="btn btn-primary btn-sm w-100 mt-1"
                                style={{ fontSize: "0.75rem" }}
                                onClick={() => navigate("/reports")}
                            >
                                <i className="fa fa-play mr-1" />
                                Run Report
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default FavReportsStrip;
